import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconMove(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M12.707 3.293a1 1 0 0 0-1.414 0l-2.5 2.5a1 1 0 0 0 1.414 1.414L11 6.414V11H6.414l.793-.793a1 1 0 0 0-1.414-1.414l-2.5 2.5a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 1.414-1.414L6.414 13H11v4.586l-.793-.793a1 1 0 0 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.414 0l2.5-2.5a1 1 0 0 0-1.414-1.414l-.793.793V13h4.586l-.793.793a1 1 0 0 0 1.414 1.414l2.5-2.5a1 1 0 0 0 0-1.414l-2.5-2.5a1 1 0 1 0-1.414 1.414l.793.793H13V6.414l.793.793a1 1 0 1 0 1.414-1.414l-2.5-2.5Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
